// extracted by mini-css-extract-plugin
module.exports = {"skill-attitude":"_0dYM8"};